import { useCallback } from "react";
import { useApolloClient, gql } from "@apollo/client";
import {
  DeleteToolsIA,
  DeleteToolsIAVariables,
} from "../__generated__/gql-types/DeleteToolsIA";

const useDeleteToolsIA = () => {
  const client = useApolloClient();
  return useCallback(
    async (input: DeleteToolsIAVariables) => {
      return await client.mutate<DeleteToolsIA>({
        mutation: DELETE_TOOLS_IA,
        fetchPolicy: "no-cache",
        variables: input,
      });
    },
    [client]
  );
};

export default useDeleteToolsIA;

const DELETE_TOOLS_IA = gql`
  mutation DeleteToolsIA($deleteToolsIaId: ID!) {
    deleteToolsIA(id: $deleteToolsIaId)
  }
`;
